import { useTranslations } from '@i18n/useLanguage'
import { MegaMenuLinks } from '../blocks/common'
import { faUser, faHouseBuilding } from '@fortawesome/pro-solid-svg-icons'
import { MegaMenuGrid } from '../blocks/MegaMenuGrid'
import { TextLink } from '@app/components/core/link/TextLink'

const StartMenu = () => {
  const t = useTranslations().app.nav.megaMenu.startMenu

  return (
    <MegaMenuGrid
      columns={[
        {
          items: [
            {
              to: MegaMenuLinks.startInitiativeArticle,
              icon: faUser,
              label: t.citizens.label,
              description: t.citizens.description,
              backgroundColor: 'var(--fine-pink)',
              children: (
                <>
                  <TextLink
                    size="small"
                    to={MegaMenuLinks.startInitiativeArticle}
                    containerStyle={{
                      textDecoration: 'none',
                      paddingLeft: '4rem',
                    }}
                  >
                    {t.citizens.links.startInitiative}
                  </TextLink>
                  <TextLink
                    size="small"
                    to={MegaMenuLinks.startGroupArticle}
                    containerStyle={{
                      textDecoration: 'none',
                      paddingLeft: '4rem',
                    }}
                  >
                    {t.citizens.links.registerProject}
                  </TextLink>
                </>
              ),
            },
          ],
        },
        {
          items: [
            {
              to: MegaMenuLinks.startDeveloperArticle,
              icon: faHouseBuilding,
              label: t.companies.label,
              description: t.companies.description,
              backgroundColor: 'var(--shades-yellow-300)',
            },
          ],
        },
      ]}
    />
  )
}

export default StartMenu
